export const PITOOLS_CONTACT_US_URL = 'https://river.amazon.com/?org=HCP&q0=989134b6-01de-4eb4-a383-ab555a8d955e';

export const PITOOLS_GETTING_STARTED_URL = "https://w.amazon.com/bin/view/ProfitIntelligence/PITools/Accuracy_Analytics/";

export const SPOTLIGHT_GETTING_STARTED_URL = "https://w.amazon.com/bin/view/ProfitIntelligence/SpotCP/SpotLight/";

// Nexus-BCM base URLs per stage, confirmed from Nexus-BCM src/config/DraftsConfig.tsx.
// Note: dev intentionally targets beta (Nexus-BCM has no standalone dev domain).
export const BCM_BASE_URL_BY_STAGE = Object.freeze({
  prod: 'https://console.harmony.a2z.com/nexus-bcm',
  gamma: 'https://gamma.console.harmony.a2z.com/nexus-bcm',
  beta: 'https://beta.console.harmony.a2z.com/nexus-bcm',
  dev: 'https://beta.console.harmony.a2z.com/nexus-bcm',
});

const TATTVA_CHAT_PATH = '/ai-assistant/chat?agent=Tattva';

// Resolve the Tattva chat URL.
//
// INITIAL ROLLOUT: every environment — including PROD Phoenix — is deliberately
// pointed at BETA Nexus-BCM while the Tattva agent is in beta. That is why the
// button is labelled "Ask Tattva (Beta)": a prod user clicking it lands in beta
// BCM, and the label has to say so.
//
// The `stage` argument and BCM_BASE_URL_BY_STAGE above are kept intentionally.
// To graduate to real per-stage routing, drop the override below and restore:
//   const normalizedStage = (stage || '').toLowerCase();
//   const baseUrl = BCM_BASE_URL_BY_STAGE[normalizedStage] || BCM_BASE_URL_BY_STAGE.beta;
// getCurrentStage() returns uppercase keys ('PROD', 'ALPHA', 'LOCAL') or 'test',
// hence the lower-casing, and an unknown stage falls back to beta so we never
// route an unrecognised environment into PROD BCM.
//
// eslint-disable-next-line no-unused-vars -- `stage` is retained for the callers
// and for the stage-aware behaviour this reverts to.
export const getTattvaChatUrl = (stage) => {
  const baseUrl = BCM_BASE_URL_BY_STAGE.beta;
  return `${baseUrl}${TATTVA_CHAT_PATH}`;
};

export const COMPONENT_DOCUMENTATION_BASE_URL = 'https://w.amazon.com/bin/view/ProfitIntelligence/HistoricalCP';

// From https://w.amazon.com/bin/view/ProfitIntelligence/ContributionProfit
export const COMPONENT_TO_LINK = Object.freeze({
  // GMS
  GMS: `${COMPONENT_DOCUMENTATION_BASE_URL}/GMS`,
  TOTAL_GMS: `${COMPONENT_DOCUMENTATION_BASE_URL}/GMS`,
  PRODUCT_GMS: `${COMPONENT_DOCUMENTATION_BASE_URL}/GMS`,
  TOTAL_PRODUCT_GMS: `${COMPONENT_DOCUMENTATION_BASE_URL}/GMS`,

  // Net Revenue
  REVENUE_SHARE: `${COMPONENT_DOCUMENTATION_BASE_URL}/RevenueShare`,
  SHIPPING_REVENUE: `${COMPONENT_DOCUMENTATION_BASE_URL}/ShippingRevenue`,
  SALES_DISCOUNTS: `${COMPONENT_DOCUMENTATION_BASE_URL}/SalesDiscounts`,
  SUBSCRIPTION_REVENUE: `${COMPONENT_DOCUMENTATION_BASE_URL}/SubscriptionRevenue`,
  CLOSING_FEES: `${COMPONENT_DOCUMENTATION_BASE_URL}/ClosingFees`,
  FULFILLMENT_FEES: `${COMPONENT_DOCUMENTATION_BASE_URL}/FulfillmentFees`,
  REFUNDS_REVENUE: `${COMPONENT_DOCUMENTATION_BASE_URL}/RefundsCost`,
  GIFTWRAP_REVENUE: `${COMPONENT_DOCUMENTATION_BASE_URL}/GiftWrapRevenue`,
  LIQUIDATION_REVENUE: `${COMPONENT_DOCUMENTATION_BASE_URL}/LiquidationRevenue`,
  WD_LIQUIDATION_REVENUE: `${COMPONENT_DOCUMENTATION_BASE_URL}/WDLiquidationRevenue`,
  OTHER_REVENUE: `${COMPONENT_DOCUMENTATION_BASE_URL}/OtherRevenue`,
  DISPLAY_ADS: `${COMPONENT_DOCUMENTATION_BASE_URL}/DisplayAds`,

  // Cost of Goods Sold (COGS)
  PRODUCT_COGS: `${COMPONENT_DOCUMENTATION_BASE_URL}/ProductCost`,
  SHIPPING_COST: `${COMPONENT_DOCUMENTATION_BASE_URL}/ShippingCost`,
  VENDOR_ALLOWANCES: `${COMPONENT_DOCUMENTATION_BASE_URL}/ContraCOGS`,
  DISCRETIONARY_COOP: `${COMPONENT_DOCUMENTATION_BASE_URL}/ContraCOGS`,
  QUICK_PAY_DISCOUNTS: `${COMPONENT_DOCUMENTATION_BASE_URL}/QuickPayDiscounts`,
  VENDOR_RETURNS: `${COMPONENT_DOCUMENTATION_BASE_URL}/VendorReturns`,
  INBOUND_FREIGHT: `${COMPONENT_DOCUMENTATION_BASE_URL}/InboundFreight`,
  FREE_REPLACEMENT_COST: `${COMPONENT_DOCUMENTATION_BASE_URL}/FreeReplacementCost`,
  REFUNDS_COST: `${COMPONENT_DOCUMENTATION_BASE_URL}/RefundsCost`,
  GIFTWRAP_COGS: `${COMPONENT_DOCUMENTATION_BASE_URL}/GiftWrapRevenue`,
  COGS_ADJUSTMENTS: `${COMPONENT_DOCUMENTATION_BASE_URL}/COGSAdjustmentsPPV`,
  LIQUIDATION_COGS: `${COMPONENT_DOCUMENTATION_BASE_URL}/LiquidationRevenue`,
  WD_LIQUIDATION_COST: `${COMPONENT_DOCUMENTATION_BASE_URL}/WDLiquidationRevenue`,
  SELLER_CREDITS: `${COMPONENT_DOCUMENTATION_BASE_URL}/SellerCredits`,
  OTHER_COSTS: `${COMPONENT_DOCUMENTATION_BASE_URL}/OtherCost`,

  // Variable Operating Expense (OPEX)
  VARIABLE_FC_COSTS: `${COMPONENT_DOCUMENTATION_BASE_URL}/VariableFC`,
  VARIABLE_CS_COSTS: `${COMPONENT_DOCUMENTATION_BASE_URL}/VariableCSCost`,
  ASSOCIATE_FEES: `${COMPONENT_DOCUMENTATION_BASE_URL}/AssociateFees`,
  SPONSORED_LINK_FEES: `${COMPONENT_DOCUMENTATION_BASE_URL}/SponsoredLinkCost`,
  PAYMENT_FEES: `${COMPONENT_DOCUMENTATION_BASE_URL}/PaymentFees`,
  BAD_DEBT: `${COMPONENT_DOCUMENTATION_BASE_URL}/BadDebt`,

  // FC Fixed
  STORAGE_AND_THROUGHPUT: 'https://w.amazon.com/bin/view/ProfitIntelligence/HistoricalFCFixed',
});



// WEBPACK FOOTER //
// ./src/constants/urls.jsx